import { Chart, ChartTimerName } from '@frontend/chart/types';

import { createMonthlyTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';

export const TRANSACTION_TIMER_ACTIVE_VOLUME_BAR_CHART_MOCK_DATA: Chart = createMonthlyTimeSeriesMockData({
    series: [
        { name: ChartTimerName.TRANSACTION_DROP_OFF_PENDING, scale: 1.2 },
        { name: ChartTimerName.TRANSACTION_PICK_UP_PENDING, scale: 0.85 }
    ]
});
